import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./css/index.scss";
import "leaflet/dist/leaflet.css";
import { Provider } from "react-redux";
import store from "./store";
import { injectStore } from "./api/instance";

injectStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
    </Provider>,
);
